// extracted by mini-css-extract-plugin
export default {"mainDiv":"contactUs_mainDiv__SqbiS","text1":"contactUs_text1__fKCL9","text2":"contactUs_text2__KkhlG","text3":"contactUs_text3__q+HeE","helloButton":"contactUs_helloButton__Rlrlx"};